module.exports = __webpack_public_path__ + "static/media/Societe-Execution-Immobiliere-Vaud.9a0bbff8.jpg";